import PermContactCalendarRoundedIcon from "@mui/icons-material/PermContactCalendarRounded";

export const contactCalendar = (props) => {
  return <PermContactCalendarRoundedIcon {...props} />;
};
